<template>
    <div>
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;height: 100%;">
                            <el-row style="background-color: #f5fbfe;padding: 10px;margin: 0;" v-if="loginMsgIsShow">
                                <el-col :span="14">上次登录时间：{{ form.last_login_time_show }}</el-col>
                                <el-col :span="10" style="text-align: right;"><i class="el-icon-close"
                                                                                 style="cursor: pointer;"
                                                                                 @click="closeLoginMsg()"></i></el-col>
                            </el-row>
                            <p style="border-bottom: 1px solid #d6d6da;padding-bottom: 10px;">账号信息</p>
                            <el-form :model="form" label-position="right" label-width="100px" class="formInfo">
                                <el-form-item class="itemForm" label="用户名:">
                                    <span>{{ form.username }}</span>
                                </el-form-item>
                                <el-form-item class="itemForm" label="用户ID:">
                                    <span>{{ form.id }}</span>
                                </el-form-item>
                                <el-form-item class="itemForm" label="昵称:">
                                    <span v-show="!nicknameIsModify">{{ form.nickname }}</span> <span
                                    v-show="!nicknameIsModify" style="cursor: pointer;
    color: #45a5fa;margin-left: 1em;" @click="modifyNickname">编辑</span>
                                    <el-input v-show="nicknameIsModify" type="text" placeholder="请输入昵称"
                                              v-model="form.nickname" minlength="4"
                                              maxlength="20" @blur="saveNickname" @change="saveNickname"
                                              style="width: 200px;"
                                              :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-form-item class="itemForm" label="性别:">
                                    <span v-show="!sexIsModify">{{ form.sex_show }}</span>
                                    <span
                                        v-show="!sexIsModify" style="cursor: pointer;
    color: #45a5fa;margin-left: 1em;" @click="modifySex">编辑</span>
                                    <el-dropdown v-show="sexIsModify" size="mini" trigger="click"
                                                 style="margin-right: 10px;">
                                        <span class="el-dropdown-link spanLink" style="color: #01bafd;">{{
                                                form.sex_show
                                            }}<i
                                                class="el-icon-arrow-down el-icon--right"></i></span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="saveSex(form.id, 1)">男</el-dropdown-item>
                                            <el-dropdown-item @click.native="saveSex(form.id, 0)">女</el-dropdown-item>
                                            <el-dropdown-item @click.native="saveSex(form.id, 2)">未知</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </el-form-item>
                                <el-form-item class="itemForm" label="手机号:">
                                    <span>{{ form.mobile | mobileSafety }}</span>
                                </el-form-item>
                                <el-form-item class="itemForm" label="邮箱:">
                                    <span>{{ form.email | emailSafety }}</span>
                                </el-form-item>
                                <el-form-item class="itemForm" label="注册时间:">
                                    <span>{{ form.reg_time_show }}</span>
                                </el-form-item>
                                <el-form-item class="itemForm" label="注册IP:">
                                    <span>{{ form.reg_ip }}</span>
                                </el-form-item>
                            </el-form>
                            <div v-if="form.is_teacher">
                                <p style="border-bottom: 1px solid #d6d6da;padding-bottom: 10px;">教师资料</p>
                                <el-form :model="form" label-position="right" label-width="100px" class="formInfo">
                                    <el-form-item class="itemForm" label="姓名:">
                                        <span>{{ form.real_name }}</span>
                                    </el-form-item>
                                    <el-form-item class="itemForm" label="职称:">
                                        <span>{{ rank }}</span>
                                    </el-form-item>
                                    <el-form-item class="itemForm" label="简介:">
                                        <span>{{ intro }}</span>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import HdAside from '../public/Aside.vue'

export default {
    name: 'UserCenter',
    components: {
        HdHeader,
        HdFooter,
        HdAside
    },
    created () {
        this.getInfo()
    },
    data: function () {
        return {
            loginMsgIsShow: true,
            form: {},
            intro: '',
            rank: '',
            nicknameIsModify: false,
            sexIsModify: false
        }
    },
    methods: {
        closeLoginMsg: function () {
            this.loginMsgIsShow = false
        },
        getInfo () {
            let that = this
            this.$ajax.get('/api/user/get').then(function (r) {
                that.form = r.data
                if (r.data.is_teacher) {
                    that.getTeacherInfo()
                }
            })
        },
        getTeacherInfo () {
            let that = this
            this.$ajax.get('/api/teacher/getbyuid').then(function (r) {
                that.intro = r.data.intro
                that.rank = r.data.rank
            })
        },
        modifyNickname () {
            this.nicknameIsModify = true
        },
        saveNickname () {
            if (this.form.nickname.length === 0) {
                return
            }
            let that = this
            //保存
            this.$ajax.post('/api/user/update', {
                id: this.form.id,
                nickname: this.form.nickname
            }).then(function (res) {
                that.nicknameIsModify = false
                that.showSuccess('昵称保存成功')
            })
        },
        modifySex () {
            this.sexIsModify = true
        },
        saveSex (id, type) {
            let that = this
            this.$ajax.post('/api/user/update', {
                id: id,
                sex: type
            }).then(function (r) {
                that.sexIsModify = false
                that.showSuccess('保存成功')
                that.getInfo()
            })
        }
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}

.formInfo span {
    color: #333333;
}

.spanLink {
    cursor: pointer;
    color: #01bafd;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserCenter.vue